import { cn } from '@/utils/cn'

interface BrandIconProps {
  size?: number
  className?: string
}

export function BrandIcon({ size = 20, className = '' }: BrandIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="280 400 290 290"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-brand-primary', className)}
      aria-label="RegenerAI"
    >
      {/* Landscape / field */}
      <path d="M485.57,571.58c-40.02,18.36-74.62,46.58-100.42,82.2-6.99-3.17-13.59-6.62-19.98-11.07,35.75-41.98,87.38-77.09,141.16-89.45,15.81-3.63,34.04-5.79,50.19-5.26.06,1.35-.05,2.75-.33,4.06-25.09,2.95-47.71,9.01-70.63,19.52Z" />
      <path d="M431.92,663.65c-11.47-.4-22.57-1.82-33.25-5.27,10.99-16.83,23.81-31.39,38.3-44.54,24.48-22.08,52.91-39.18,83.9-50.28,6.68-2.39,18.07-5.77,24.75-7.12l10.08-2.04c.14,1.62-.01,2.85-.61,4.24-34.79,10.26-64.99,28.69-89.66,55.38-13.47,14.79-24.67,31.24-33.51,49.63Z" />
      <path d="M484.22,651.71c-11.2,5.51-23.11,9.09-35.66,10.71l4.99-10.22c19.89-40.77,58.73-75.1,101.27-91.16l-1.73,8-8.28,5.11c-28.17,17.38-50.08,45.52-60.58,77.56Z" />
      <path d="M411.24,590.06c-31.36-19.95-64.74-31.45-101.73-33.5l-1.09-8.55c12.11-.45,23.51.76,35.53,2.36,28.75,4.64,55.9,14.83,81.01,30.2l-13.71,9.49Z" />
      <path d="M358.67,638.13c-16.16-12.47-28.81-27.99-37.67-45.91-1.62-3.3-3.02-6.19-4.08-9.82,22.67,7.32,43.43,19.08,61.55,34.71-7.06,6.85-13.47,13.5-19.8,21.03Z" />
      <path d="M391.7,605.27l-4.33,3.49c-22.47-17.43-46.62-29.2-73.93-35.36-1.3-3.98-2.16-7.4-2.75-11.46l13.99,2.15c28.03,4.3,53.93,16.2,77.8,32.35l-10.78,8.84Z" />
      <path d="M502.26,641.42c6.55-23.07,23.75-46.54,42.11-61.26l6.67-5.35c-.68,2.8-1.38,4.97-2.38,7.47-4.23,10.59-9.59,20.35-16.3,29.67-8.44,11.26-18.21,20.98-30.11,29.46Z" />
      {/* Dots */}
      <circle cx="457.38" cy="498.49" r="7.25" />
      <circle cx="409.49" cy="498.52" r="7.25" />
      <circle cx="433.42" cy="491.96" r="7.24" />
      <circle cx="474.91" cy="516.1" r="7.19" />
      <circle cx="391.95" cy="516.1" r="7.21" />
      <circle cx="391.21" cy="481.83" r="6.05" />
      <circle cx="411.21" cy="471.38" r="6.04" />
      <circle cx="433.47" cy="467.76" r="6.04" />
      <circle cx="475.58" cy="481.76" r="6.02" />
      <circle cx="455.54" cy="471.43" r="6" />
      <circle cx="365.08" cy="517.96" r="6.01" />
      <circle cx="375.3" cy="497.72" r="5.99" />
      <circle cx="501.73" cy="517.87" r="6" />
      <circle cx="491.49" cy="497.69" r="5.98" />
      <circle cx="408.58" cy="447.1" r="4.85" />
      <circle cx="501.14" cy="472" r="4.84" />
      <circle cx="525.94" cy="515.26" r="4.82" />
      <circle cx="458.21" cy="447.1" r="4.82" />
      <circle cx="433.44" cy="443.76" r="4.79" />
      <circle cx="481.28" cy="456.73" r="4.79" />
      <circle cx="365.72" cy="472" r="4.73" />
      <circle cx="385.51" cy="456.8" r="4.8" />
      <circle cx="340.88" cy="515.29" r="4.76" />
      <circle cx="516.37" cy="491.86" r="4.76" />
      <circle cx="350.45" cy="491.86" r="4.75" />
      <circle cx="333.89" cy="473.2" r="3.57" />
      <circle cx="348.74" cy="454.97" r="3.55" />
      <circle cx="410.06" cy="422.2" r="3.55" />
      <circle cx="456.73" cy="422.19" r="3.53" />
      <circle cx="366.86" cy="440.17" r="3.53" />
      <circle cx="550.86" cy="516.66" r="3.57" />
      <circle cx="532.93" cy="473.19" r="3.54" />
      <circle cx="322.74" cy="494" r="3.53" />
      <circle cx="387.56" cy="429.04" r="3.53" />
      <circle cx="544.02" cy="494.02" r="3.58" />
      <circle cx="316" cy="516.73" r="3.53" />
      <circle cx="499.95" cy="440.12" r="3.53" />
      <circle cx="433.33" cy="419.83" r="3.48" />
      <circle cx="479.17" cy="429.06" r="3.52" />
      <circle cx="518" cy="454.9" r="3.53" />
    </svg>
  )
}
